<template>
  <div class="jg-item-box">
    <div class="jg-item-info">
      <div class="info-header">
        <div class="info-cover">
          <img
            v-if="item.imgUrl && item.imgUrl !== 'null'"
            :src="$global.imgUrl + item.imgUrl"
            alt=""
          />
          <img
            v-else
            :src="require('@/assets/mylogin/default-JG.png')"
            alt=""
          />
        </div>
        <div class="info-title">{{ item.shopsName }}</div>
      </div>
      <van-button
        round
        type="info"
        color="#4A79F1"
        style="width: 64px"
        @click="toAuthor(item.shopsTypeId, item.companyId)"
        >进店</van-button
      >
    </div>
    <div class="content-list">
      <div
        class="content-list-item"
        v-for="(subItem, index) in item.goodsList"
        :key="index"
        @click="toDetail(subItem.id)"
      >
        <img
          class="item-pic"
          v-if="subItem.albumPics && subItem.albumPics !== 'null'"
          :src="$global.imgUrl + subItem.albumPics.split(',')[0]"
          alt=""
        />
        <img
          class="item-pic"
          v-else
          :src="require('@/assets/img/mobile-img/zz_default.png')"
          alt=""
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  methods: {
    // 跳转商家详情页
    toAuthor(type, id) {
      console.log(type, id);
      // type: 1->机构 2->百科
      let out = this.$route.query.out;
      switch (type) {
        case "1":
          this.$router.push({
            path: "/appusesjigou",
            query: {
              item: 2,
              id,
              out,
            },
          });
          break;
        case "2":
          this.$router.push({
            path: "/appusesbaike",
            query: {
              item: 1,
              id,
              out,
            },
          });
          break;
      }
    },
    toDetail(id) {
      this.$router.push("/detail/report?id=" + id);
    },
  },
};
</script>

<style scoped lang="scss">
.jg-item-box {
  background: #ffffff;
  border-radius: 8px;
  overflow: hidden;
  .jg-item-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 12px;
    .info-header {
      display: flex;
      align-items: center;
      .info-cover {
        width: 45px;
        height: 45px;
        background: #ffffff;
        border: 1px solid #eeeeee;
        border-radius: 50%;
        margin-right: 12px;
        > img {
          width: 45px;
          height: 45px;
          object-fit: contain;
          border-radius: 50%;
        }
      }
      .info-title {
        font-weight: 600;
        font-size: 15px;
        color: #333333;
        line-height: 21px;
        max-width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }
    }
    ::v-deep .van-button {
      height: 30px;
    }
  }
  .content-list {
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    padding: 0 0 12px 12px;
    &::-webkit-scrollbar {
      display: none;
    }
    .content-list-item {
      margin-right: 12px;
      margin-bottom: 0;
      background: #ededed;
      width: 90px;
      height: 90px;
      border-radius: 8px;
      > img {
        width: 90px;
        height: 90px;
        border-radius: 8px;
        object-fit: contain;
      }
    }
  }
}
</style>
